(function ($) {
  'use strict';

  /**
   * Date Countdown Bar
   * ---
   */

  $.fn.dateCountdown = function () {
    var $this = $(this);
    var countdown_to = $this.data( 'countdown-to' );
    var date_countdown = new Date( countdown_to ).getTime();

    // Number Container Els
    var $count_days = $this.find( '.js-date-countdown-days' );
    var $count_hours = $this.find( '.js-date-countdown-hours' );
    var $count_minutes = $this.find( '.js-date-countdown-minutes' );
    var $count_numbers = $count_days
      .add( $count_hours )
      .add( $count_minutes );

    // Timesup El
    var $timesup = $('.js-date-countdown-timesup');

    // Calc countdown on page load
    calc_countdown( date_countdown, $count_days, $count_hours, $count_minutes, $timesup );

    // Format numbers for styling
    format_coundown_numbers( $count_numbers );

    /**
     * Time Ticker
     * - Run ticker every minute
     */
    var ticker = setInterval(function () {
      // Calc countdown on page load
      calc_countdown( date_countdown, $count_days, $count_hours, $count_minutes, $timesup );

      // Format numbers for styling
      format_coundown_numbers( $count_numbers );
    }, 60000 );

    return this;
  };


  /**
   * Calculate Countdown Date
   * - Calculates amount of time until given date
   * - Displays countdown as 'days : hours : minutes'
   */
  function calc_countdown( date_countdown, $count_days, $count_hours, $count_minutes, $timesup ) {
    var date_now = new Date().getTime();
    var date_distance = date_countdown - date_now;

    // Time's Up!
    if ( date_distance <= 0 ) {
      $timesup.html( 'It is time!' );
      return false;
    }

    // Calculate Date & Time
    var days = Math.floor(
      date_distance
      / ( 1000 * 60 * 60 * 24 )
    )
      .toString()
      .padStart( 3, '0' );
    var hours = Math.floor(
      ( date_distance % ( 1000 * 60 * 60 * 24 ) )
      / ( 1000 * 60 * 60 )
    )
      .toString()
      .padStart( 2, '0' );
    var minutes = Math.floor(
      ( date_distance % ( 1000 * 60 * 60 ) )
      / ( 1000 * 60 )
    )
      .toString()
      .padStart( 2, '0' );

    // Update Display Numbers
    $count_days.html( days );
    $count_hours.html( hours );
    $count_minutes.html( minutes );

    return false;
  }


  /**
   * Format Countdown Numbers for Styling
   * - Wraps characters in a given selector in separate
   *   'span' tags for styling purposes
   */
  function format_coundown_numbers( $html ) {
    $html.html(function ( i, html ) {
      return html.replace( /(\d)/g, '<span>$1</span>' );
    });
  }

})(jQuery);
